import { ThemeOptions, createTheme } from "@mui/material";
import { MuiButton } from "./overrides/MuiButton";
import { MuiCard } from "./overrides/MuiCard";
import { MuiChip } from "./overrides/MuiChip";
import { MuiOutlinedInput } from "./overrides/MuiOutlinedInput";
import { MuiFormControlLabel } from "./overrides/MuiFormControlLabel";
import { TeamConfig } from "../hooks/useTeamConfig";
import { colorScheme } from "./colorScheme";

declare module "@mui/material/Chip/Chip" {
  interface ChipPropsSizeOverrides {
    large: true;
  }
}

const typography = {
  fontFamily: [
    "Poppins",
    "Instrument Sans",
    "-apple-system",
    "Inter",
    "Helvetica",
    "Arial",
    "sans-serif",
  ].join(","),

  h1: {},
  h2: {},
  h3: {},
  h4: {},
  h5: {},
  h6: {},
  subtitle1: {
    fontSize: "1.1rem",
  },
  subtitle2: {
    fontSize: "1rem",
  },
  body1: {},
  body2: {},
};

const components = {
  MuiCssBaseline: {
    styleOverrides: `
      @font-face {
        font-family : 'Instrument Sans';
        font-style : normal;
        font-display : swap;
        font-weight : 400;
        font-smooth : always;
      };

      // google map sdk autocomplete zIndex fix
      .pac-container {
        z-index: 9999999;
      }
      `,
  },
  MuiButton,
  MuiCard,
  MuiChip,
  MuiFormControlLabel,
  MuiOutlinedInput,
};

export const createTeamTheme = (config: TeamConfig) => {
  let mode: "light" | "dark" = "light";
  let colors = colorScheme[mode as keyof typeof colorScheme];

  return createTheme({
    typography,
    components,
    palette: {
      mode,
      primary: {
        main: config.colors.primary,
      },
      success: {
        main: "#33A55A",
      },
      text: {
        primary: colorScheme["light"].onSurfacePrimary,
        secondary: "#616161",
      },
      divider: colors.onSurfaceBorder,
      background: {
        default: "#F7FAFC",
        paper: "#FFFFFF",
      },
      // ...config.palette,
    },
    shape: {
      borderRadius: 8,
    },
  });
};
